import { Editor } from '@tinymce/tinymce-react';
import React, { useRef } from 'react'

function TinyEditor({form, name, height, width, editData=null, ...restProps}) {
  const editorRef = useRef()

  return (
    <Editor
      ref={editorRef}
      {...restProps}
      onInit={(e, editor) => (editorRef.current = editor)}
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      // onChange={() => {}}
      init={{
        selector: "#editor",
        height: height ? height : "400px",
        width: width ? width : "100%",
        branding: false,
        toolbar:
          "undo redo bold italic | alignleft aligncenter alignright alignjustify | forecolor lineheight bullist numlist outdent indent removeformat",
        content_css: false,
        toolbar_mode: "sliding",
        content_style: `
            @import url('https://fonts.cdnfonts.com/css/sf-pro-display'); 
            body {
              font-family: 'SF Pro Display', sans-serif;
            }
          `,
        plugins: [
          "advlist",
          "autolink",
          "lists",
          "link",
          "image",
          "charmap",
          "preview",
          "anchor",
          "help",
          "searchreplace",
          "visualblocks",
          "code",
          "insertdatetime",
          "media",
          "table",
          "wordcount",
        ],
        block_formats: "Догол мөр=p; Гарчиг 1=h2; Гарчиг 2=h3",
        font_size_formats:
          "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
        font_family_formats: "SF Pro Display=SF Pro Display, sans-serif;",
        file_picker_callback: function (callback, value, meta) {
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");
          input.onchange = function () {
            var file = this.files[0];
            var reader = new FileReader();
            reader.onload = function (e) {
              callback(e.target.result, {
                alt: file.name,
              });
            };
            reader.readAsDataURL(file);
          };
          input.click();
        },
      }}
      onChange={(e) => {}}
      onEditorChange={(e, editor) => {
        restProps.onChange(e);
        // form.setFieldValue(name, e)
      }}
    />
  );
}

export default TinyEditor